import { loadStripe } from '@stripe/stripe-js'
import i18n from '../i18n'

let platformStripePromise
const connectedAccountStripePromises = {}

export function getPlatformStripe() {
  if (!platformStripePromise) {
    platformStripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
  }

  return platformStripePromise
}

// The program fee PaymentIntent lives on the community's connected account, so its 3DS
// challenge can only be handled by a Stripe instance scoped to that account
export function getConnectedAccountStripe(stripeAccountId) {
  if (!connectedAccountStripePromises[stripeAccountId]) {
    connectedAccountStripePromises[stripeAccountId] = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, { stripeAccount: stripeAccountId })
  }

  return connectedAccountStripePromises[stripeAccountId]
}

export function cardSetupElementsOptions(clientSecret) {
  return {
    clientSecret,
    locale: i18n.language,
    appearance: {
      variables: {
        colorPrimary: '#ff6633',
        colorText: '#1d2933',
        colorTextPlaceholder: '#9aa1ab',
        borderRadius: '10px',
        fontFamily: '"Lato", sans-serif',
        fontSizeBase: '15px',
        focusOutline: 'none',
        focusBoxShadow: '0 0 0 1px #ff6633',
      },
      rules: {
        '.Input': { borderColor: '#c3c9d1', padding: '12px 14px', lineHeight: '1.5' },
        '.Input:focus': { borderColor: '#ff6633' },
      },
    },
  }
}
